window.addEventListener('load',function() {
    let stepButton = document.querySelector('body:not(.template-page) .subscription-popup .step__one .step-button');
    if(stepButton) {
        document.querySelector('body:not(.template-page) .subscription-popup .step__one .step-button').addEventListener('click', function () {
            let productHandle = document.querySelector('.product__item.active').dataset["productHandle"]
            let sellingPlanId = product_selling_plans[productHandle][0].id
            document.querySelectorAll('.subscription-popup form [name*="selling_plan"]').forEach((field) => {
                field.value = sellingPlanId
            });
            document.querySelectorAll('.subscription-popup .subscription-input').forEach((item) => {
                item.addEventListener('change', (e) => {
                    let activeContainer = document.querySelector('.subscription-popup .step__three-content.active');
                    let productSubscriptionItems = [].slice.call(activeContainer.querySelectorAll('.subscription-item'));
                    let productSubscriptionItem = activeContainer.querySelector('.subscription-item.active');
                    productHandle = document.querySelector('.product__item.active').dataset["productHandle"]
                    sellingPlanId = product_selling_plans[productHandle][productSubscriptionItems.indexOf(productSubscriptionItem)].id
                    document.querySelectorAll('.subscription-popup form [name*="selling_plan"]').forEach((field) => {
                        field.value = sellingPlanId
                    })
                })
            });
        });
    }
});

window.updateMonthSelection = function(event, id) {
  var selectedValue = event.target.value;
  var inputElements = document.querySelectorAll('#' + id);
  
  for(var i = 0; i < inputElements.length; i++) {
  	var inputElement = inputElements[i];
    inputElement.value = selectedValue;
  }
};